import { getUseProductsCacheKey } from '@/lib/hooks/useProducts';
import { useAppSelector } from '@/redux/hooks';
import React from 'react';
import { useEffect } from 'react';
import { initialState } from '../forms/Filters/filterSlice';
import {
  useSetFormInUrl,
  useUpdateFiltersByUrl,
} from '../forms/Filters/filterStateInUrl';
import ProductsList from '../section/ProductsList';
import Seo from '../Seo';
import Layout from './Layout';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { captureException } from '@sentry/nextjs';
import { getProducts } from '@/lib/repository/products/products';

export default function CategoryPage() {
  const allFilters = useAppSelector((state) => state.productFilter);
  useUpdateFiltersByUrl();
  const { updateUrl } = useSetFormInUrl(allFilters);
  useEffect(() => {
    updateUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFilters]);

  return (
    <Layout>
      <Seo />
      <ProductsList />
    </Layout>
  );
}

export async function getCategoryStaticProps(
  categoryName:
    | 'machine-tool'
    | 'sheet-metal'
    | 'plastics-processing'
    | 'automation-equipment'
    | 'wood-working'
    | '',
  locale = 'en-US'
) {
  const queryClient = new QueryClient();
  try {
    const fetchProductsCacheKey = getUseProductsCacheKey({
      ...initialState,
      categoryApiName: categoryName,
      locale,
    });

    await queryClient.fetchQuery(
      fetchProductsCacheKey,
      async () => {
        return {
          products: await getProducts({
            machine_category: categoryName,
            locale,
          }),
        };
      },
      {
        retry: 3,
        retryDelay: 1000,
      }
    );
  } catch (error) {
    console.error(error);
    captureException(error);
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60 * 60 * 3,
  };
}
